import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button } from 'react-native-paper';
import PropTypes from 'prop-types';

export default function LanguageSelection({
  appStyles,
  pageContent,
  stepForward,
  updateLanguage,
}) {
  return (
    <View style={styles.container}>
      <Text>{pageContent[0]}</Text>
      <Text>{pageContent[1]}</Text>
      {/* <Text>{pageContent[2]}</Text> */}
      <Button
        mode="contained"
        style={appStyles.button}
        labelStyle={appStyles.labelStyle}
        onPress={() => {
          updateLanguage('en');
          stepForward();
        }}
      >
        {pageContent[3]}
      </Button>
      <Button
        mode="contained"
        style={appStyles.button}
        labelStyle={appStyles.labelStyle}
        onPress={() => {
          updateLanguage('es');
          stepForward();
        }}
      >
        {pageContent[4]}
      </Button>
      {/* <Button
        mode="contained"
        style={styles.button}
        onPress={() => {
          updateLanguage('qu');
          stepForward();
        }}
      >
        {pageContent[5]}
      </Button> */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 6.75,
    margin: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

LanguageSelection.propTypes = {
  stepForward: PropTypes.func,
  updateLanguage: PropTypes.func,
};
